/**
 * Bundle entry — `wwwroot/Scripts/amri-login.js`.
 *
 * Loaded by `_Layout.cshtml` after jQuery + amri-home. Side-effects on import:
 *   - Wires the auth modal toggles (login / register / reset-password) via
 *     event delegation on document.
 *   - Auto-opens the login modal on first paint when a server-side auth error
 *     surfaced (TempData["AuthError"]) OR when ?showLoginModal=1 is present.
 */
import './amri'; // ensures `window.Amri` exists (shared with amri-home)
import { initAuthModals } from './auth/login';
import { initRegisterModal } from './auth/register';
import { initResetPasswordForm } from './auth/reset-password';
import { initNewsletterFooterForm } from './newsletter/footer-subscribe';

function onReady(callback: () => void): void {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
    } else {
        callback();
    }
}

onReady(() => {
    initAuthModals();
    initRegisterModal();
    initResetPasswordForm();
    initNewsletterFooterForm();
});
